import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const AdminCareers = lazy(() => import("@/pages/admin/AdminCareers"));

export const Route = createFileRoute("/admin/careers")({
  component: AdminCareers,
});
